export default "__VITE_ASSET__D4vC8hpw__"